import axios from "axios";

function baseAPI(use_token = true, content_type = null) {

	const base_url = import.meta.env.VITE_API_URL;
	const token = localStorage.getItem('user-token');
	
	let header = {
		'Accept': 'application/json',
		"Content-type": "application/json",
	}
	if (use_token) header['Authorization'] = `Bearer ${token}`;
	if (content_type) header["Content-type"] = content_type; 

	const api = axios.create({
		baseURL: base_url,
		headers: header
	});

	// before a request is made start the nprogress
	api.interceptors.request.use(config => {
		return config
	})

	// before a response is returned stop nprogress
	api.interceptors.response.use(response => {
		return response
	})

	return api;
}


export default baseAPI;